

import React, { useEffect, useState } from "react"; 
import ReusableTable from "../../../components/common/table";
import { Button, Popconfirm, Space } from "antd";
import { ReactComponent as AddSvg } from "../../../assets/images/add.svg";
import FilterComponent from "../../../components/common/filter";
import { useNavigate } from "react-router";
import ConfirmModal from "../../../components/common/alert-popup";
import { ReactComponent as ViewSvg } from "../../../assets/images/action/view.svg";
import { ReactComponent as DeleteSvg } from "../../../assets/images/action/delete.svg";
import { ReactComponent as EditSvg } from "../../../assets/images/action/edit.svg";
import { ReactComponent as DisableSvg } from "../../../assets/images/action/Shield Cross.svg";
import CommonFilter from "../../../components/common/filter";
import { urlConstant } from "../../../constants/urlConstant";
import { useDispatch, useSelector } from "react-redux";
import { listNotificationFun } from "../../../redux/reducer/NotificationSlice";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "../../../customHooks";
import { Tooltip } from 'antd';

const NotificationList = () => {
  const [filteredData, setFilteredData] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(1);
  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });

  const [searchParams, setSearchParams] = useSearchParams();
  // Convert URLSearchParams to usable object
  const getInitialParams = () => {
    const page = parseInt(searchParams.get("page")) || 1;
    const size = parseInt(searchParams.get("size")) || 10;
    const search_key = searchParams.get("search_key") || "all";
    const search_value = searchParams.get("search_value") || "";
    const status = searchParams.get("status");
    const type = searchParams.get("type");
    const position = searchParams.get("position");

    return {
      page,
      size,
      search_key,
      search_value,
      status: status !== null ? Number(status) : undefined,
      type: type !== null ? Number(type) : undefined,
      position: position !== null ? Number(position) : undefined,
    };
  };

  const [tableParams, setTableParams] = useState(getInitialParams());

useEffect(() => {
  const params = {
    page: tableParams.page,
    size: tableParams.size,
    search_key: tableParams.search_key,
    search_value: tableParams.search_value,
  };

  if (tableParams.status !== undefined) params.status = tableParams.status;
  if (tableParams.type !== undefined) params.type = tableParams.type;
  if (tableParams.position !== undefined) params.position = tableParams.position;

  setSearchParams(params);
}, [tableParams, setSearchParams]);


  const {listNotificationCount, listNotification, listNotificationLoading} = useSelector((prev) => prev?.notification)

  const debouncedSearchValue = useDebounce(tableParams.search_value, 500);



  useEffect(()=>{
    dispatch(listNotificationFun(tableParams))
  },[tableParams, tableParams.page, tableParams.size,
    debouncedSearchValue,
    tableParams.status,
    tableParams.type,
    tableParams.position,])



const paginationConfig = {
  pageSizeOptions: ["10", "20", "50"], 
  showSizeChanger: true, 
  showQuickJumper: true, 
  total:  listNotificationCount || 1, 
  current: tableParams.page, 
  pageSize: tableParams.size, 
  type: tableParams.type,
  onChange: (page, pageSize) => {
    // setCurrentPage(page); 
    setTableParams((prev) => ({ ...prev, page, size: pageSize }));
  },
};



  const handleDateFilter = (dates, dateStrings) => {
    if (!dates) {
      setFilteredData(dataSource);
      return;
    }
    const [startDate, endDate] = dateStrings;
    const filtered = dataSource.filter((item) => {
      const itemDate = new Date(item.date_added);
      return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
    });
    setFilteredData(filtered);
  };
  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };

  const closeModal = () => {
    setModalConfig({ open: false, actionType: "" });
  };

  const handleConfirm = () => {
    console.log(`Confirmed ${modalConfig.actionType} action`);
    closeModal();
  };
  const handleSearch = (searchText) => {
    const filtered = dataSource.filter((item) =>
      item.tenant_name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) => (tableParams.page - 1) * tableParams.size + index + 1, 
      width: "100px"
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      type: "search",
      render: (text) => {
        if (text && text.length > 25) {
          return (
            <Tooltip title={text}>
              {`${text.substring(0, 25)}...`}
            </Tooltip>
          );
        }
        return text;
      },
    },
    {
      title: "Description",
      dataIndex: "message",
      key: "description",
      type: "search",
      render: (text) => {
        if (text && text.length > 25) {
          return (
            <Tooltip title={text}>
              {`${text.substring(0, 25)}...`}
            </Tooltip>
          );
        }
        return text;
      },
    },
    {
      title: "Date Added",
      dataIndex: "created_at",
      key: "date_added",
      // type: "date",
      // render: (date) => dayjs(date).format("MM-DD-YYYY"),
      render: (date) => {
        const dateObject = new Date(date);
        const day = String(dateObject.getUTCDate()).padStart(2, '0');       
        const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0'); 
        const year = dateObject.getUTCFullYear();                          
        return `${month}-${day}-${year}`;
      },
    },
    {
      title: "Tenant Name",
      dataIndex: "name_en",
      key: "status",
      type: "select",
      width: "180px",
    },
  ];
  
  const dataSource = [
    {
      key: "1",
      sr_no: "1",
      title: "Acme Corp",
      description: "Lorem ipsum lorem ipsum",
      podcast_added: 50,
      status: "Active",
      date_added: "2024-02-15",
    },
    {
      key: "2",
      sr_no: "2",
      title: "Tech Solutions",
      description: "Lorem ipsum lorem ipsum",
      podcast_added: 120,
      status: "Inactive",
      date_added: "2023-05-10",
    },
    {
      key: "3",
      sr_no: "3",
      title: "Innovate Inc.",
      description: "Lorem ipsum lorem ipsum",
      podcast_added: 80,
      status: "Active",
      date_added: "2024-03-01",
    },
  ];
  

  const actionItems = (record) => [
    {
      key: "view",
      label: (
        <>
          <ViewSvg style={{ marginRight: 8 }} />
          View Details
        </>
      ),
      onClick: (record) => navigate(urlConstant?.viewNotification),
    },
    {
      key: "edit",
      label: (
        <>
          <EditSvg style={{ marginRight: 8, color: "red" }} />
          Edit Details
        </>
      ),
      onClick: (record) => navigate(urlConstant?.addNotification),
    },
    {
      key: "disable",
      label: (
        <>
          <DisableSvg style={{ marginRight: 8, color: "red" }} />
          Disable
        </>
      ),
      onClick: () => showModal("disable"),
    },
    {
      key: "delete",
      label: (
        <>
          <DeleteSvg style={{ marginRight: 8, color: "red" }} />
          Delete Notification
        </>
      ),
      onClick: () => showModal("delete"),
    },
  ];
  const handleFilterChange = (key, value, reset = false) => {

    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
          search_key: "",
          search_value: "",
          status: undefined,
          position: undefined,
          
        };
      }
      else if (key === "status" || key==="type" || key === "position") {
        return {
          ...prev,
          [key]: value === 0 ? 0 : (value === 1 ? 1 : undefined),
          search_key: undefined,
          search_value: undefined,
        };
      }
      return {
        ...prev,
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };
  return (
    <div>
      <div className="addBx">
        <div className="filterBx">
          {/* <Space>
            <CommonFilter
              columns={columns}
              onFilterChange={handleFilterChange}
            />
          </Space> */}
        </div>
        <Button
          type="primary"
          icon={<AddSvg />}
          onClick={() => navigate(urlConstant?.addNotification)}
        >
          Send Notification
        </Button>
      </div>
      <div className="tableHeading">List of Notification Added</div>
      <ReusableTable
        columns={columns}
        dataSource={listNotification}
        loading={listNotificationLoading}
        paginationConfig={paginationConfig}
        // actionItems={(record) => actionItems(record)}
      />
      <ConfirmModal
        titlePrefix="Author"
        messagePrefix="Author"
        open={modalConfig.open}
        onClose={closeModal}
        onConfirm={handleConfirm}
        actionType={modalConfig.actionType}
      />
    </div>
  );
};

export default NotificationList;
